module.exports = __webpack_public_path__ + "static/media/tools.e15f276f.svg";